
import { EnhancedSetControls } from "../controls/EnhancedSetControls";
import { SetData } from "../types";

interface Exercise {
  id: string;
  name: string;
  sets: number;
  reps: number;
  weight: number;
  set_data: SetData[];
  exercise_rest_time?: number;
  set_rest_time?: number;
}

interface ExerciseProgressProps {
  exercise: Exercise;
  onUpdate: (exerciseId: string, field: string, value: number | SetData[] | string) => void;
  isPersonalPlan?: boolean;
}

export const ExerciseProgress = ({ 
  exercise, 
  onUpdate, 
  isPersonalPlan = false 
}: ExerciseProgressProps) => {
  console.log(`📊 ExerciseProgress for ${exercise.id}:`, {
    exerciseRestTime: exercise.exercise_rest_time,
    setRestTime: exercise.set_rest_time,
    sets: exercise.sets,
    setDataLength: exercise.set_data?.length || 0,
    isPersonalPlan
  });

  return (
    <div className="space-y-4">
      <EnhancedSetControls
        exerciseId={exercise.id}
        sets={exercise.sets}
        reps={exercise.reps}
        weight={exercise.weight}
        setData={exercise.set_data || []}
        exerciseRestTime={exercise.exercise_rest_time || 60}
        setRestTime={exercise.set_rest_time || 30}
        onUpdate={onUpdate}
        isPersonalPlan={isPersonalPlan}
      />
    </div>
  );
};
